import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { userApi } from "../api/user.api";
import { loadStoredUser } from "./loadStoredUser";

export const useUser = () => {
    const { user, isAuthenticated, isLoading: isAuthLoading, getToken } = useKindeAuth();

    const query = useQuery({
        queryKey: ["user", user?.id],
        queryFn: () => {
            const userId = user!.id;
            return loadStoredUser(
                userId,
                {
                    email: user!.email ?? "",
                    givenName: user!.givenName,
                    familyName: user!.familyName,
                },
                getToken
            );
        },
        enabled: isAuthenticated && !!user?.id,
        // Настройки кеширования: баланс может меняться, но не каждую секунду.
        // Оставляем staleTime 1 минуту, чтобы не дергать базу при переходах.
        staleTime: 60 * 1000,
    });

    return {
        user: query.data,
        isLoading: isAuthLoading || query.isLoading,
        isError: query.isError,
        error: query.error,
    };
};

export const useUpdateUser = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: userApi.updateUser,
        onSuccess: (_, variables) => {
            queryClient.invalidateQueries({ queryKey: ["user", variables.id] });
        },
    });
};
